'use client'

import { useEffect } from 'react'

interface StylesWindow extends Window {
  __htPublicStyles?: { href: string; load: () => Promise<void>; ready: Promise<void>; loaded: boolean }
}

// Initial documents use the native paint observer. Client navigations do not
// emit the server bootstrap; ordinary public routes retain the full sheet,
// and this fallback also handles a new deployment's content-addressed URL.
export const PublicStylesHydration = ({ href }: { href: string }) => {
  useEffect(() => {
    if ((window as StylesWindow).__htPublicStyles?.href === href) {
      return
    }
    if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
      return
    }
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    link.dataset.precedence = 'ht-public'
    document.head.appendChild(link)
  }, [href])

  return null
}
